import useSimBilling from 'api/sims/useSimBilling';
import useSimDetails from 'api/sims/useSimDetails';
import { DateTime } from 'luxon';
import apiDateToDateTime from 'utils/dates/apiDateToDateTime';

interface UseIsDeactivatedOldSimProps {
  hologramSimId?: HologramSimId;
}

const useIsDeactivatedOldSim = ({ hologramSimId }: UseIsDeactivatedOldSimProps) => {
  const { simDetails, isLoading: isSimLoading, error: simError } = useSimDetails(hologramSimId);

  const {
    simBilling,
    error: simBillingError,
    isLoading: simBillingIsLoading,
  } = useSimBilling(hologramSimId);

  const { billingPeriodEnd } = simBilling;

  const billingPeriodEndDateTime = billingPeriodEnd
    ? apiDateToDateTime(billingPeriodEnd)
    : undefined;

  return {
    isDeactivatedOldSim:
      simDetails.networkStatus === 'DEAD' &&
      (!billingPeriodEndDateTime || billingPeriodEndDateTime <= DateTime.now()),
    isLoading: isSimLoading || simBillingIsLoading,
    error: simError || simBillingError,
  };
};

export default useIsDeactivatedOldSim;
